import { ContentColumnQuery } from '@blocks/content/columns/ColumnQuery';
import { ContentDescriptionLargeQuery } from '@blocks/content/descriptionLarge/DescriptionLargeQuery';
import { ContentInfoQuery } from '@blocks/content/info/InfoQuery';
import { ContentQuoteListQuery } from '@blocks/content/quoteList/QuoteListQuery';
import { BlockQuery, BlockQueryCollection } from '@queries/datoCMS';
import { gql } from 'graphql-request';
import { z } from 'zod';

const ContentBlocksQuery = new BlockQueryCollection([
	ContentDescriptionLargeQuery,
	ContentInfoQuery,
	ContentQuoteListQuery,
	ContentColumnQuery
]);

export const DoubleContentBlockQuery = new BlockQuery(
	'double_content',
	gql`
		... on DoubleContentRecord {
			_modelApiKey
			first{
				${ContentBlocksQuery}
			}
			firstTheme
			second{
				${ContentBlocksQuery}
			}
			secondTheme
		}
	`,
	z.object({
		_modelApiKey: z.enum(['double_content']),
		first: ContentBlocksQuery.validation,
		firstTheme: z.enum(['light', 'dark', 'faded']),
		second: ContentBlocksQuery.validation,
		secondTheme: z.enum(['light', 'dark', 'faded'])
	}),
	(data) => {
		return {
			...data,
			// We wrap it in an array to enable the use of the BlockRenderer component
			// TODO: BlockRenderer should be able to accept both arrays and single items
			first: [data.first],
			second: [data.second]
		};
	}
);

export type DoubleContentBlock = z.infer<typeof DoubleContentBlockQuery.validation>;
